(function (angular, app) {
   "use strict";

    angular.module(app.modules.common.name)
        .constant(app.modules.common.constants.calendarlist,
        
         [
            {month : "January" , abbr : "Jan" , index : 0 , days : 31}
            ,{month : "February" , abbr : "Feb" , index : 1 , days : 28}
            ,{month : "March" , abbr : "Mar" , index : 2 , days : 31}
            ,{month : "April" , abbr : "Apr" , index : 3 , days : 30}
            ,{month : "May" , abbr : "May" , index : 4 , days : 31}
            ,{month : "June" , abbr : "Jun" , index : 5 , days : 30}
            ,{month : "July" , abbr : "Jul" , index : 6 , days : 31}
            ,{month : "August" , abbr : "Aug" , index : 7 , days : 31}
            ,{month : "September" , abbr : "Sep" , index : 8 , days : 30}
            ,{month : "October" , abbr : "Oct" , index : 9 , days : 31}
            ,{month : "November" , abbr : "Nov" , index : 10 , days : 30}
            ,{month : "December" , abbr : "Dec" , index : 11 , days : 31}
            ]      
        );
}(angular, app));
